// import GET_MOVIE from "src/queries/getMovie";
// import GET_MOVIE_LIST from "src/queries/getMovieList";
import GET_USER_PROFILE from 'src/queries/getUserProfile';
import getLocalUser from 'src/user/getLocalUser';

const addMovieToListUpdate = ({ userProfile }) => (
  cache,
  { data: { addMovieToList } }
) => {
  const userProfileData = cache.readQuery({
    query: GET_USER_PROFILE,
    variables: { id: userProfile.id, userToken: getLocalUser().token },
  }) as any;
  userProfileData.userProfile[addMovieToList.movieListType].items[
    addMovieToList.movieId
  ] = {};

  cache.writeQuery({
    data: userProfileData,
    query: GET_USER_PROFILE,
    variables: { id: userProfile.id, userToken: getLocalUser().token },
  });

  // const movieListId = userProfile[addMovieToList.movieListType].id;
  // try {
  //     const movieListData = cache.readQuery({ query: GET_MOVIE_LIST, variables: { id: movieListId, filter } }) as any;
  //     const movieData = cache.readQuery({ query: GET_MOVIE, variables: { id: movieId } }) as any;
  //     movieListData.movieList.items.push(movieData.movie);

  //     cache.writeQuery({
  //         data: movieListData,
  //         query: GET_MOVIE_LIST,
  //         variables: { id: movieListId, filter }
  //     });
  // } catch (error) {
  //     console.log(error);
  // }
};

export default addMovieToListUpdate;



// WEBPACK FOOTER //
// ./src/cache/addMovieToList.ts